import React, { useRef, useState } from 'react';

interface Currency { gold: number; giftCertificates: number }
interface Props {
  currency: Currency; enabled: boolean;
  request: (path: string, data: any) => Promise<any>;
  onExchanged: (currency: Currency) => void;
}
export function GoldExchange({ currency, enabled, request, onExchanged }: Props) {
  const [amount, setAmount] = useState('1');
  const [confirming, setConfirming] = useState(false), [busy, setBusy] = useState(false);
  const [error, setError] = useState(''), [message, setMessage] = useState('');
  const pending = useRef<{ requestId: string; gold: number }>();
  const running = useRef(false);
  const gold = Number(amount), coupons = gold * 2;
  const valid = enabled && Number.isSafeInteger(gold) && gold > 0 && Number.isSafeInteger(coupons) && gold <= currency.gold;
  async function exchange() {
    if (running.current || (!pending.current && !valid)) return;
    running.current = true; setBusy(true); setError('');
    try {
      pending.current ??= { requestId: Array.from(crypto.getRandomValues(new Uint8Array(16)), n => n.toString(16).padStart(2, '0')).join(''), gold };
      const result = await request('exchange-gold', pending.current);
      onExchanged(result.currency);
      setMessage(`แลกสำเร็จ ${result.gold.toLocaleString('th-TH')} โกลด์ ได้รับ ${result.coupons.toLocaleString('th-TH')} คูปอง`);
      pending.current = undefined; setConfirming(false);
    } catch (e) {
      setError((e as Error).message || 'เชื่อมต่อไม่สำเร็จ กรุณายืนยันอีกครั้ง');
      if ((e as any).server) pending.current = undefined;
    } finally { running.current = false; setBusy(false); }
  }
  return <>
    <section className="uc-gold-exchange" aria-label="แลกโกลด์เป็นคูปอง">
      <div><h3>แลกโกลด์เป็นคูปอง</h3><p>1 โกลด์ = 2 คูปอง</p></div>
      <form onSubmit={e => { e.preventDefault(); if (valid) { setMessage(''); setError(''); setConfirming(true); } }}>
        <label>จำนวนโกลด์<input aria-label="จำนวนโกลด์ที่ต้องการแลก" type="number" min="1" step="1" max={currency.gold}
          value={amount} disabled={!enabled || busy || !!pending.current} onChange={e => setAmount(e.target.value)} /></label>
        <span>ได้รับ {Number.isSafeInteger(coupons) && gold > 0 ? coupons.toLocaleString('th-TH') : 0} คูปอง</span>
        <button className="uc-primary" type="submit" disabled={!valid || busy}>แลกคูปอง</button>
      </form>
      {!enabled && <small>สร้างตัวละครก่อนแลกคูปอง</small>}
      {message && <p role="status">{message}</p>}
    </section>
    {confirming && <div className="uc-modal-backdrop"><section className="uc-purchase-modal" role="dialog" aria-modal="true" aria-label="ยืนยันแลกโกลด์">
      <h2>ยืนยันแลกโกลด์</h2><p>ใช้ {gold.toLocaleString('th-TH')} โกลด์ รับ {coupons.toLocaleString('th-TH')} คูปอง</p>
      <p>อัตราแลกเปลี่ยน 1 โกลด์ = 2 คูปอง</p>
      {error && <p role="alert">{error}</p>}
      <div className="uc-modal-actions">
        <button onClick={() => setConfirming(false)} disabled={busy || !!pending.current}>ยกเลิก</button>
        <button className="uc-primary" onClick={exchange} disabled={busy || (!pending.current && !valid)}>{busy ? 'กำลังแลก…' : 'ยืนยันแลก'}</button>
      </div>
    </section></div>}
  </>;
}
